const redirect = () => {
  try {
    const currentUrl = new URL(location.href);
    const referrer = document.referrer;
    const refUrl = new URL(referrer);

    if (refUrl.origin === currentUrl.origin) {
      const relativeRedirect = `${refUrl.pathname}${refUrl.search}${refUrl.hash}`;
      location.href = relativeRedirect;

      return;
    }
    location.href = "/";
  } catch (error) {
    location.href = "/";
  }
};

export default redirect;
